import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('username', email);
      params.append('password', password);
      const res = await api.post('/api/auth/login', params);
      localStorage.setItem('prot_token', res.data.access_token);
      localStorage.setItem('prot_user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: '48px 40px',
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        textAlign: 'center',
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 24 }}>
          <img
            src="/logo-white.png"
            alt="JMB Engineering"
            style={{
              height: 56,
              objectFit: 'contain',
              filter: 'invert(1) brightness(0) saturate(100%) invert(12%) sepia(60%) saturate(800%) hue-rotate(200deg)',
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        </div>

        {/* Title */}
        <h1 style={{
          color: '#1a1a2e',
          fontSize: 28,
          fontWeight: 700,
          margin: '0 0 6px',
          letterSpacing: '-0.5px',
        }}>
          Protection Platform
        </h1>
        <p style={{
          color: '#0f3460',
          fontSize: 14,
          fontWeight: 500,
          margin: '0 0 8px',
          letterSpacing: 0.2,
        }}>
          Power System Protection Management
        </p>
        <p style={{
          color: '#aaa',
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: 2,
          margin: '0 0 32px',
          textTransform: 'uppercase',
        }}>
          ENGINEERING. EXCELLENCE. DELIVERED.
        </p>

        {/* Error */}
        {error && (
          <div style={{
            background: '#fff5f5',
            border: '1px solid #f44336',
            borderRadius: 6,
            color: '#f44336',
            fontSize: 13,
            padding: '10px 14px',
            marginBottom: 20,
            textAlign: 'left',
          }}>
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px 14px',
                border: '1.5px solid #e0e0e0',
                borderRadius: 8,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s',
                fontFamily: 'inherit',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#0f3460')}
              onBlur={(e) => (e.target.style.borderColor = '#e0e0e0')}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px 14px',
                border: '1.5px solid #e0e0e0',
                borderRadius: 8,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s',
                fontFamily: 'inherit',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#0f3460')}
              onBlur={(e) => (e.target.style.borderColor = '#e0e0e0')}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '13px',
              background: loading ? '#ccc' : '#1a1a2e',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              letterSpacing: 0.5,
              fontFamily: 'inherit',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={{ color: '#bbb', fontSize: 11, marginTop: 32 }}>
          © 2026 JMB Engineering Pty Ltd
        </p>
      </div>
    </div>
  );
};

export default Login;
